module.exports = __webpack_public_path__ + "prod/1.42.2/img/jiuyang-icon.62cdefb2.png";